module.exports = __webpack_public_path__ + "88038152931e8acddc3f44a559a8495f.png";